/* eslint-disable @typescript-eslint/no-explicit-any */
import { type PropertyValue } from '@/types'
import { useRouter } from 'next/router'
import { useMemo, type ReactNode } from 'react'

interface FilterGroup {
  className?: string
  inputClassName?: string
  option: PropertyValue
  children: ReactNode
  onChange: (
    e: { name: string; value: string | null }[],
    routerChange?: boolean
  ) => void
  activeOption?: {
    name: string
    values: string[]
  }
  isQuickFilter?: boolean
  type: string
}
export function FilterGroup({
  className = '',
  type,
  children,
  option,
  activeOption,
  onChange,
  isQuickFilter,
}: FilterGroup) {
  const router = useRouter()
  const handleFilterChange = (ev: any) => {
    const { value } = ev.target
    if (activeOption) {
      const hasValue = activeOption.values.includes(value)
      const newValues = hasValue
        ? activeOption.values.filter(v => v !== value).join()
        : [...activeOption.values, value].join()
      onChange(
        [
          {
            name: activeOption.name,
            value: newValues || null,
          },
        ],
        isQuickFilter
      )
    }
  }

  const checked = useMemo(() => {
    return activeOption?.values.includes(option.value.vi) || false
  }, [router.query])

  return (
    <>
      {type === 'checkbox' ? (
        <div className={`form-check-filter box-checkbox ${className}`}>
          <input
            id={`checkbox-${option._id}`}
            type='checkbox'
            value={option.value.vi}
            checked={checked}
            onChange={e => {
              handleFilterChange(e)
            }}
            className='form-checkbox-input'
          />
          <label
            htmlFor={`checkbox-${option._id}`}
            className='form-checkbox-label flex cursor-pointer flex-wrap'
          >
            {children}
          </label>
        </div>
      ) : (
        <>
          <label
            htmlFor={`filter-${option._id}`}
            className='control--label for-checkbox relative'
          >
            <div
              className={`m-0 flex h-9 cursor-pointer items-center justify-center rounded border px-2 ${
                checked ? 'border-primary-base' : 'border-white'
              } type-layout-prefix uppercase ${className}`}
            >
              {children}
            </div>
            <input
              className='absolute m-[-1px] h-[1px] p-0 invisible'
              id={`filter-${option._id}`}
              type='checkbox'
              value={option.value.vi}
              checked={checked}
              onChange={e => {
                handleFilterChange(e)
              }}
            />
          </label>
        </>
      )}
    </>
  )
}

export default FilterGroup
